import { useFormikContext } from 'formik';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { optionsStyle } from '../composables';
import { getAdvice } from '../../../../redux/visit';
import useDebounce from '../../../../utils/useDebounceHook';

const Advise = () => {
	const { values, setFieldValue } = useFormikContext();
	const [adviseOptions, setAdviseOptions] = useState([]);
	const { advice } = useSelector((state) => state.visits);
	const dispatch = useDispatch();
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearch = useDebounce(searchTerm, 500);

	useEffect(() => {
		if (advice.length > 0) {
			const newOptions = advice.map((a) => ({
				value: a.id,
				label: a.name,
				isNew: false,
			}));

			setAdviseOptions((prev) => {
				const merged = [...prev, ...newOptions];
				return merged.filter(
					(opt, index, self) =>
						index === self.findIndex((o) => o.value === opt.value)
				);
			});
		}
	}, [advice]);

	useEffect(() => {
		if (debouncedSearch) {
			dispatch(
				getAdvice({ search: debouncedSearch, per_page: 5, status: 'active' })
			);
		}
	}, [debouncedSearch, dispatch]);

	const handleChange = (selected) => {
		const mapped = (selected || [])
			.map((opt) => {
				if ((opt.__isNew__ || opt.isNew) && opt.label.trim() !== '') {
					return {
						id: `new-${Date.now()}-${Math.random()}`,
						adviceName: opt.label.trim(),
					};
				}
				if (opt.value && !opt.__isNew__) {
					return { id: `adv-${opt.value}`, adviceId: opt.value };
				}
				return null;
			})
			.filter(Boolean);

		const newOptions = (selected || [])
			.filter((opt) => opt.__isNew__ && opt.label.trim() !== '')
			.map((opt) => ({
				value: opt.label.trim(),
				label: opt.label.trim(),
				isNew: true,
			}));

		setAdviseOptions((prev) => {
			const merged = [...prev, ...newOptions];
			return merged.filter(
				(opt, index, self) =>
					index === self.findIndex((o) => o.value === opt.value)
			);
		});
		setFieldValue('advice', mapped);
	};

	const selectedValue = (values.advice || [])
		.map((item) => {
			if (item.adviceId) {
				return adviseOptions.find((opt) => opt.value === item.adviceId);
			}
			if (item.adviceName) {
				return {
					value: `new-${item.adviceName}`,
					label: item.adviceName,
					isNew: true,
				};
			}
			return null;
		})
		.filter(Boolean);

	return (
		<Row className="my-3">
			<Card.Title>{t('VISIT.ADVICE')}</Card.Title>
			<Col md={12}>
				<CreatableSelect
					isMulti
					menuPortalTarget={document.body}
					styles={optionsStyle}
					isClearable
					options={adviseOptions}
					value={selectedValue}
					onChange={handleChange}
					onInputChange={(inputValue, { action }) => {
						if (action === 'input-change') {
							setSearchTerm(inputValue);
						}
					}}
					isValidNewOption={(inputValue, _selectValue, selectOptions) =>
						!!inputValue.trim() &&
						!selectOptions.some((opt) => opt.label.toLowerCase() === inputValue.trim().toLowerCase())
					}
					filterOption={(option, rawInput) =>
						!selectedValue.some(
							(sel) => sel.label.toLowerCase() === option.label.toLowerCase()
						) && option.label.toLowerCase().includes(rawInput.toLowerCase())
					}
				/>
			</Col>
		</Row>
	);
};

export default Advise;
